// Recovered compiled webpack factory 22461. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "denormalizePagePath", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(55287),
    a = r(78305);
  function o(e) {
    let t = (0, a.normalizePathSep)(e);
    return t.startsWith("/index/") && !(0, n.isDynamicRoute)(t)
      ? t.slice(6)
      : "/index" !== t
        ? t
        : "/";
  }
}
